export enum RolesEnum {
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
  /** Granted for a built-in Admin or Account Admin permission group (backend `AuthoritiesConstants.ADMIN`). */
  ADMIN = 'ROLE_ADMIN',
  ATTORNEY = 'ATTORNEY',
  CLIENT = 'CLIENT',
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  USER = 'ROLE_USER',
  ATTORNEY_USER = 'ATTORNEY_USER',
  CLIENT_USER = 'CLIENT_USER',
  ANONYMOUS = 'ROLE_ANONYMOUS'
}
